import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { RadioButton } from "primereact/radiobutton";
import React, { useEffect, useState, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import { getCurrentUserFromLocalStorage } from "../../helpers/localStorageHelper";
import { translate } from "../../localization/translateService";
import { trainerRegistration } from "../../services/trainersAPIService";
import { getTrainerByUserIdLanding } from "../../services/trainersService";
import { HttpStatusCode } from "axios";
import { GENDERS } from "../../constants/app-constants";
import PhoneNumberInput from "../input/PhoneNumberInput";
import { getLanguageOptions } from "../../helpers/languageHelper";
import { getI18nLanguageFromLocalStorage } from "../../helpers/localStorageHelper";
import LanguageProficiency from "../table/TableLanguageSpeaking.jsx";
import { getCountryName } from "../../helpers/getCountryName.js";
import useGeoLocation from "react-ipgeolocation";
import confetti from "canvas-confetti";
import { Toast } from "primereact/toast";
import EducationQualification from "../table/EducationQualification.jsx";
import { getCountry } from "../../services/flag";
import {
  getAvailableProficiencies,
  getAvailableGraduationStatus,
  getAvailableDegrees
} from "../../services/trainersService";
import { REGEX } from "../../constants/regex.js";
import { getLearnerDetailByUserId } from "../../services/learnerService.js";
import { uploadFile } from "../../services/uploadFileService.js";
import { ProgressSpinner } from 'primereact/progressspinner';
import { canvasPreview } from './canvasPreview.js'
import { useDebounceEffect } from './useDebounceEffect'
import ReactCrop, { 
  centerCrop,
  makeAspectCrop } from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import { getCountryWithPhoneCode } from '../../services/country';
import { Tooltip } from 'primereact/tooltip';
import { SuccessTemplate, ErrorTemplate } from "../common/ToastMessage/Template.jsx";
import { FileTypesAllowed, FILE_CONSTANT } from "../../constants/file-constant.js";
import { PhoneNumberUtil } from "google-libphonenumber";
import { getFileIconByExtension } from "../../helpers/fileHelpers.js";
import TrainerRegistrationFormFooter from "./TrainerRegistrationFormFooter.jsx";

const defaultGraduationData = {
                  university: "",
                  department: "",
                  degree: "",
                  graduationStatus: ""
                }
const emailRegex = REGEX.EMAIL;
const phoneNumberWithCountryCodeRegex = REGEX.PHONENUMBERWITHPHONECODE;
const TrainerRegistrationForm = ({ props, setVisible }) => {
  const minCropHeight = 100;
  const unit = "%";
  const SELFINTRODUCTION_MAXLENGTH = 1000;
  const SELFINTRODUCTION_MINLENGTH = 30;
  const maxFileSize = FILE_CONSTANT.MAX_SIZE;
  const { formElement, invalidMessage } = props;
  const [crop, setCrop] = useState({
    unit: unit,
    x: 25,
    y: 25,
    width: 50,
    height: 50
  });
  const dialogRef = useRef(null);
  const previewCanvasRef = useRef(null)
  const imgRef = useRef(null)
  const [completedCrop, setCompletedCrop] = useState(null)
  const [scale, setScale] = useState(1)
  const [rotate, setRotate] = useState(0)
  const [aspect, setAspect] = useState(3/4)
  const [visibleCrop, setVisibleCrop] = useState(false);
  const [tempImgURL, setTempImgURL] = useState(null);
  const [eligibleFormData, setEligibleFormData] = useState({
    profileImage: null,
    fullName: null,
    nickName: null,
    phone: null,
    email: null,
    country: "",
    residenceCountry: "",
    languages: [],
    highestLevelOfEducation: null,
    selfIntroduction: null,
    gender: GENDERS.MALE.toUpperCase(),
    originCountry: "",
    languageSpoken: null,
    educationQualifications: { graduations: [], certificate: [] }
  });
  const [emailError, setEmailError] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false); // Track form submission status
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [isSubmitting, setIsSubmitting] = useState(false); // Submit button loading state
  const [countryCode, setCountryCode] = useState(null); // Loading country code
  const [uploadedProfileImage, setUploadedProfileImage] = useState(null);
  const [nationalityOptions, setNationalityOptions] = useState([]);
  const [invalidForm, setInvalidForm] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [translateText, setTranslateText] = useState({})
  const errorToast = useRef(null);
  const successToast = useRef(null);

  const location = useGeoLocation();
  const [phoneCodeOptions, setPhoneCodeOptions] = useState([]);
  const [isApprovedPolicy, setIsApprovedPolicy] = useState(false);
  const {
    control,
    handleSubmit,
    trigger,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });
  const [degreeOptions, setDegreeOptions] = useState([]);

  const [graduationStatusOptions, setGraduationStatusOptions] = useState([]);
  const [proficiencyOptions, setProficiencyOptions] = useState([]);
  const [isUploading, setIsUploading] = useState(false); // Loading state
  const phoneUtil = PhoneNumberUtil.getInstance();
  const steps = [
    { title: formElement.stepTitle.step1, pageTitle: formElement.firstFormPage.title },
    { title: formElement.stepTitle.step2, pageTitle: formElement.secondFormPage.title },
    { title: formElement.stepTitle.step3, pageTitle: formElement.thirdFormPage.title },
    { title: formElement.stepTitle.step4, pageTitle: formElement.fourthFormPage.title },
    { title: formElement.stepTitle.step5, pageTitle: formElement.fifthFormPage.title },
    { title: formElement.stepTitle.step6, pageTitle: formElement.sixthFormPage.title },
  ];

  function centerAspectCrop(
  mediaWidth,
  mediaHeight,
  aspect,
  ) {
    return centerCrop(
      makeAspectCrop(
        {
          unit: unit,
          width: 90,
        },
        aspect,
        mediaWidth,
        mediaHeight,
      ),
      mediaWidth,
      mediaHeight,
    )
  }

  const canvasRef = useRef(null);

  const myConfetti = confetti.create(canvasRef.current, {
    resize: true,
    useWorker: true,
  });

  const handleClickFirework = () => {
    myConfetti({
      particleCount: 50,
      spread: 90,
      startVelocity: 25,
      gravity: 0.5,
      angle: 110,
      ticks: 200,
      origin: { x: 0.7, y: 0.5 },
    });
    myConfetti({
      particleCount: 50,
      spread: 90,
      startVelocity: 25,
      gravity: 0.5,
      angle: 70,
      ticks: 200,
      origin: { x: 0.3, y: 0.5 },
    });
  };

  const TRANSLATION_KEYS = {
    COMMON_ITEMS_MAX_FILESIZE : "COMMON_ITEMS_MAX_FILESIZE"
  }

  const translateListData = async (originalData, optionKey = "value", optionDesciption= "label") => {
    let translatedData = [];
    for (const key of Object.keys(originalData)) {
      const newValue = await Promise.all(
        originalData[key].map(async (item) => {
          const key = await translate(item.key);
          const desciption = await translate(item.value);
          return {
            [optionDesciption]: desciption,
            [optionKey]: key,
          };
        })
      );

      translatedData = [...translatedData, ...newValue];
    }

    return translatedData;
  }

  const onSubmit = async (saveAsDraft = true) => {
    if (isSubmitting || !isApprovedPolicy) return;
    if (!saveAsDraft) {
      const isValid = await trigger();
      if (!isValid || invalidForm) {
        scrollDialogToInvalidInput();
        return;
      }
    
      setIsSubmitting(true);
    }
    
    var formattedPhone = eligibleFormData.phone;
    if (eligibleFormData.phone) {
      formattedPhone = `${countryCode.phoneCode} ${formattedPhone.trim()}`;
    }

    // Create FormData object
    const formData = new FormData();
    const currentUser = getCurrentUserFromLocalStorage();
    if (currentUser) {
      formData.append("userId", currentUser.id);
    }

    formData.append("avatar", eligibleFormData.profileImage || "");
    formData.append("displayName", eligibleFormData?.fullName?.trim() || "");
    const firstName = eligibleFormData.firstName?.trim();
    const lastName = eligibleFormData.lastName?.trim();

    formData.append("firstName", firstName || "");
    formData.append("lastName", lastName || "");

    formData.append("nickName", eligibleFormData.nickName?.trim() || "");
    formData.append("phone", formattedPhone || "");
    formData.append("email", eligibleFormData.email);
    formData.append(
      "countryOfResidence",
      eligibleFormData.residenceCountry.code || ""
    );
    eligibleFormData.languageSpoken.forEach((lang, index) => {
      if (lang.languageCode || lang.proficiencyCode) {
        formData.append(`languages[${index}].LanguageCode`, lang.languageCode || "");
        formData.append(`languages[${index}].ProficiencyCode`, lang.proficiencyCode || "");
      }
    });
    formData.append(
      "selfIntroduction",
      eligibleFormData.selfIntroduction || ""
    );

    formData.append("isActive", !saveAsDraft);
    formData.append("nationality", eligibleFormData.originCountry.code || "");
    formData.append("gender", eligibleFormData.gender || "");

    eligibleFormData.educationQualifications.certificate.forEach((cer, index) => {
      formData.append(`certificates[${index}].FileName`, cer.fileName);
      formData.append(`certificates[${index}].FilePath`, cer.filePath);
      formData.append(`certificates[${index}].ContentType`, cer.contentType);
    })
    eligibleFormData.educationQualifications.graduations.forEach((gra, index) => {
      formData.append(`trainerEducationGraduation[${index}].University`, gra.university || "");
      formData.append(`trainerEducationGraduation[${index}].Department`, gra.department || "");
      formData.append(`trainerEducationGraduation[${index}].Degree`, gra.degree || "");
      formData.append(`trainerEducationGraduation[${index}].GraduationStatus`, gra.graduationStatus || "");
    })

    formData.append("isApprovedPolicy", isApprovedPolicy);
    try {
      await trainerRegistration(formData);
      if (!saveAsDraft) {
        setIsSubmitted(true);
        handleClickFirework();
      } else {
        successToast?.current?.show({ 
          severity: "success", 
          summary: "",
          detail: invalidMessage?.saveSuccessMessage,
          life: 3000, 
          content: (props) => SuccessTemplate(props)
        });
      }

    } catch (error) {

      errorToast?.current?.show({ 
        severity: "error", 
        summary: "",
        detail: invalidMessage?.saveFailMessage,
        life: 3000, 
        content: (props) => ErrorTemplate(props)
      });
    } finally {
      if (!saveAsDraft) {
        setIsSubmitting(false);
      }
    }
  };

  const modifyImageUrl = (url) => {
    if (typeof url === "string") {
      if (url.includes(process.env.PORTAL_INSIDE_IP)) {
        return changeDomainName(url, process.env.API_ENDPOINT);
      }
    }
    return url;
  };

  const changeDomainName = (url, newDomain) => {
    // Remove the protocol (http:// or https://) from newDomain if it exists
    const sanitizedDomain = newDomain.replace(/^https?:\/\//, "");

    const modifiedUrl = url.replace(
      /\/\/([^/:]+)(:\d+)?/,
      (match, oldDomain, port) => `//${sanitizedDomain}`
    );
    // Ensure the URL uses HTTPS protocol
    return modifiedUrl.replace(/^http:/, "https:");
  };

  const scrollToElement = (element) => {
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });

      element.focus();
      return;
    }
  }

  const scrollDialogToInvalidInput = () => {
    const invalidInput = document.querySelector('.p-invalid');

    if (invalidInput) {
      scrollToElement(invalidInput);
      return;
    }
    
    const invalidTags = document.querySelector('.border-danger');
    if (invalidTags) {
      scrollToElement(invalidTags);
      return;
    }

    const dialogContent = document.querySelector('.trainer-registration-wrapper .p-dialog-content');
    if (dialogContent) {
      scrollToElement(dialogContent);
      return;
    }
  };

  const isLanguageSpokenValueValid = (languagesSpoken) => {
    let valid = true;
    if (!languagesSpoken) {
      valid = false;
    }

    languagesSpoken?.forEach(data => {
      if (!data.languageCode || !data.proficiencyCode) {
        valid = false;
      }
    });

    return valid;
  }

  const isEducationQualificationValid = (updatedData) => {
    const graduationsData = updatedData.educationQualifications.graduations;
    const isQualificationsValid = graduationsData.length > 0 && !graduationsData.find(g => !g.university || !g.department || !g.degree || !g.graduationStatus)

    return updatedData.educationQualifications.certificate.length > 0 && isQualificationsValid;
  }

  const validationForm = (updatedData) => {
    if (
      !isSubmitted &&
      (!updatedData.firstName ||
        !updatedData.lastName ||
        !updatedData.nickName ||
        !updatedData.phone ||
        !updatedData.originCountry ||
        !updatedData.residenceCountry ||
        !isLanguageSpokenValueValid(updatedData.languageSpoken) ||
        !updatedData.profileImage ||
        !isEducationQualificationValid(updatedData) ||
         (!updatedData.selfIntroduction ||
        updatedData.selfIntroduction.length < SELFINTRODUCTION_MINLENGTH ||
        updatedData.selfIntroduction.length > SELFINTRODUCTION_MAXLENGTH))
      ) {
      setInvalidForm(true);
    } 
    else {
      setInvalidForm(false);
    }
  };

  const handleInputChange =
    (field = null) =>
      (e) => {
        setEmailError("");
        const name = e.target.name;
        const value = e.target.value;
        if (field) {
          field.onChange(e);
        }

        const updatedData = {
          ...eligibleFormData,
          [name]: value,
        };
        setEligibleFormData(updatedData);

        validationForm(updatedData);
      };

  const handlePhoneChange = (field) => {

    if (field?.data?.country) {
      setCountryCode(field.data.country);
    }

    if (field.value === eligibleFormData.phone) {
      return;
    }
    const updatedData = {
      ...eligibleFormData,
      phone: field.value,
    };
    setEligibleFormData(updatedData);

    setValue("phone", field.value);
    
    trigger("phone");

    validationForm(updatedData);
  };

  const handleGenderChange = (value) => {
    const updatedData = {
      ...eligibleFormData,
      gender: value,
    };

    setEligibleFormData(updatedData);

    validationForm(updatedData);
  }

  const handleOriginCountryChange = (value) => {
    if (value === eligibleFormData.originCountry?.code) return;
    const option = nationalityOptions.find(x => x.code === value)

    const updatedData = {
      ...eligibleFormData,
      originCountry: option,
    };

    setEligibleFormData(updatedData);
    // Add this line to update the form field value
    setValue("originCountry", value);
    
    // Trigger validation for this field
    trigger("originCountry");
    validationForm(updatedData);
  }

  const handleResidenceCountryChange = (value) => {
    if (value === eligibleFormData.residenceCountry?.code) return;
    const option = nationalityOptions.find(x => x.code === value)

    const updatedData = {
      ...eligibleFormData,
      residenceCountry: option,
    };

    setEligibleFormData(updatedData);
    // Add this line to update the form field value
    setValue("residenceCountry", value);
    
    // Trigger validation for this field
    trigger("residenceCountry");
    validationForm(updatedData);
  }

  const handleLanguageSpokenChange = (value) => {
    const updatedData = {
      ...eligibleFormData,
      languageSpoken: value,
    };

    setEligibleFormData(updatedData);
    setValue("languageSpoken", value);
    
    trigger("languageSpoken");
    validationForm(updatedData);
  }

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const LoadStudentProfile = async (userId, countryData, phoneOptions, currentUser) => {
    try {
      const learner = await getLearnerDetailByUserId(userId);
      const learnerNationality = countryData.find(c => c.code === learner.data.nationality);

      let mainNumber = "";
      if (learner.data.phone && learner.data.phone.match(phoneNumberWithCountryCodeRegex)) {
        const phoneParsed = phoneUtil.parse(learner.data.phone);
        const phoneCodeDigital = "+" + phoneParsed.getCountryCode();
        const phoneCode = phoneOptions.find(p => p.phoneCode === phoneCodeDigital)
        mainNumber = phoneParsed.getNationalNumber()?.toString() ?? "";
        setCountryCode(phoneCode);
      }

      setUploadedProfileImage(learner.data.avatar);
      setEligibleFormData((prevState) => ({
        ...prevState,
        fullName: learner.data.firstName + ' ' + learner.data.lastName,
        firstName: learner.data.firstName,
        lastName: learner.data.lastName,
        nickName: learner.data.nickName,
        email: learner.data.email,
        phone: mainNumber,
        originCountry: learnerNationality,
        residenceCountry: learnerNationality,
        gender: learner.data.gender,
        profileImage: learner.data.avatar,
        educationQualifications: { graduations: [{
                  university: "",
                  department: "",
                  degree: "",
                  graduationStatus: ""
                }], certificate: [] },
      }));
    } catch (error) {
      setEligibleFormData((prevState) => ({
        ...prevState,
        fullName: currentUser.displayName,
        nickName: currentUser.nickName,
        email: currentUser.email,
      }));
    }
  }

  useEffect(() => {

    const loadTranslations = async () => {
      try {
        const translationData = {};
        
        for (const [key, translationKey] of Object.entries(TRANSLATION_KEYS)) {
          // const fallbackValue = getFallbackValue(key);
          translationData[`${key}`] = await translate(translationKey, false, '');
        }
        
        setTranslateText(translationData);
      } catch (error) {
        console.error('Failed to load translations:', error);
      }
    };

    loadTranslations();

    const getAllOptions = async () => {
      const [
        countryData,
        languages,
        phoneOptions,
        degrees,
        graduationStatus,
        proficiencies
      ] = await Promise.all([
        getCountry(),
        getI18nLanguageFromLocalStorage(),
        getCountryWithPhoneCode(location.country),
        getAvailableDegrees(),
        getAvailableGraduationStatus(),
        getAvailableProficiencies()
      ]);

      setPhoneCodeOptions(phoneOptions);
      const sortCountry = countryData;
      setNationalityOptions(sortCountry);

      const languageOptiops = await getLanguageOptions(languages);
      setLanguages(languageOptiops);
      
      const translatedDegrees = await translateListData(degrees);
      setDegreeOptions(translatedDegrees);

      const translatedGraduationStatus = await translateListData(graduationStatus);
      setGraduationStatusOptions(translatedGraduationStatus);

      const translatedProficiencies = await translateListData(proficiencies);
      setProficiencyOptions(translatedProficiencies);

      const currentUser = getCurrentUserFromLocalStorage();
      if (currentUser) {
        // Flatten availableTags for easier lookup
        const getTrainer = async (id) => {
          try {
            const response = await getTrainerByUserIdLanding(id);
            if (response) {
              setUploadedProfileImage(response.avatar);
              
              // phone
              let mainNumber = "";
              if (response.phone && response.phone.match(phoneNumberWithCountryCodeRegex)) {
                const phoneParsed = phoneUtil.parse(response.phone);
                const phoneCodeDigital = "+" + phoneParsed.getCountryCode();
                const phoneCode = phoneOptions.find(p => p.phoneCode === phoneCodeDigital)
                mainNumber = phoneParsed.getNationalNumber()?.toString() ?? "";
                setCountryCode(phoneCode);
              }
              let graduationList = [];
              if (!response.trainerEducationGraduation || response.trainerEducationGraduation.length === 0) {
                const graduationData = {
                  university: "",
                  department: "",
                  degree: "",
                  graduationStatus: ""
                }
                graduationList = [graduationData];
              } else {
                graduationList = response.trainerEducationGraduation;
              }

              
              setEligibleFormData((prevState) => ({
                ...prevState,
                fullName: response.fullName,
                nickName: response.nickName,
                firstName: response.firstName,
                lastName: response.lastName,
                phone: mainNumber,
                email: response.email,
                residenceCountry: countryData.find(c => c.code === response.countryOfResidence),
                teachingStyle: response.teachingStyle,
                languageSpoken: response.languages && response.languages.length > 0 ? response.languages : null,
                originCountry: countryData.find(c => c.code === response.nationality),
                gender: response.gender,
                profileImage: response.avatar,
                educationQualifications: { graduations: graduationList, certificate: response.certificates },
                selfIntroduction: response.selfIntroduction,
                universityName: response.university,
                departmentName: response.department,
                highestLevelOfEducation: response.highestLevelOfEducation,
              }));
              if (response.isActive) {
                setIsSubmitted(true);
              }
            }
            else {
              await LoadStudentProfile(id, countryData, phoneOptions, currentUser);
            }
          }
          catch (error) {
            if (error.status === HttpStatusCode.NotFound) {
              await LoadStudentProfile(id, countryData, phoneOptions, currentUser);

            }
          }
        };

        await getTrainer(currentUser.id);
      }

      setIsLoading(true);
    }
    getAllOptions();

  }, []);

  const countryOptionTemplate = (option) => {
    return (
      <div className="justify-content-start align-items-center flex gap-1">
        <div className="keduall-icon flag-circle-country small-size justify-content-center align-items-center flex">
          <span className={`flag img flex fi fi-${option.code.toLowerCase()}`} />
        </div>
        <div className="flex keduall-typography text-16-normal-400 text-default-txt">{option.name}</div>
      </div>
    );
  };

  const selectedCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div className="justify-content-start align-items-center flex gap-1">
          <div className="keduall-icon flag-circle-country small-size justify-content-center align-items-center flex text-default-txt keduall-typography text-16-normal-400">
            <span className={`flag img flex fi fi-${option.code.toLowerCase()}`} />
          </div>
          <div className="flex keduall-typography text-16-normal-400 text-default-txt">{option.name}</div>
        </div>
      );
    }
    return <span className="p-placeholder">{props.placeholder}</span>;
  };

  const handleAddEducationQuafificaion = () => {
    const graduationData = {
      university: "",
      department: "",
      degree: "",
      graduationStatus: ""
    }

    const updatedData = {
      ...eligibleFormData,
      educationQualifications: {
        ...eligibleFormData.educationQualifications,
        graduations: [...eligibleFormData.educationQualifications.graduations, graduationData],
      },
    };

    setEligibleFormData(updatedData);
    validationForm(updatedData);
  }

  const handleUpdateGraduations = (index) => {
    const newGraduations = eligibleFormData.educationQualifications.graduations.filter((_, i) => i !== index);

    if (newGraduations.length === 0) {
      
    }

    const updatedData = {
      ...eligibleFormData,
      educationQualifications: {
        ...eligibleFormData.educationQualifications,
        graduations: newGraduations.length ? newGraduations : [defaultGraduationData]
      },
    };
    

    setEligibleFormData(updatedData);
    validationForm(updatedData);
  }

  const handleUpdateCertificates = (item) => {
    const updatedData = {
      ...eligibleFormData,
      educationQualifications: {
        ...eligibleFormData.educationQualifications,
        certificate: [...eligibleFormData.educationQualifications.certificate, item]
      },
    };
    setEligibleFormData(updatedData);
    validationForm(updatedData);
  }

  const handleRemoveCertificate = (index) => {
    const newCertificate = eligibleFormData.educationQualifications.certificate.filter((_, i) => i !== index);

    const updatedData = {
      ...eligibleFormData,
      educationQualifications: {
        ...eligibleFormData.educationQualifications,
        certificate: newCertificate,
      },
    };

    setEligibleFormData(updatedData);
    validationForm(updatedData);
  }

  const handleHide = () => {
    if (isSubmitting) return;
    setVisible(false);
    onSubmit();
  }

  const handleHideCrop = () => {
    setVisibleCrop(false);
    setTempImgURL(null);
    setIsUploading(false);
    setCompletedCrop(null);
  }

  const getEducationQualificationsValue = () => {
    const newGraduations = [];
    for (const value of eligibleFormData.educationQualifications.graduations) {
      const graduationData = {
        university: value?.university ?? "",
        department: value?.department ?? "",
        degree: value.degree ? value.degree : "",
        graduationStatus: value.graduationStatus ? value.graduationStatus : ""
      }

      newGraduations.push(graduationData)
    }

    const newCertificates = [];

    for (const index in eligibleFormData.educationQualifications.certificate) {
      const certificateData = eligibleFormData.educationQualifications.certificate[index];
      const fileObject = {
      id: index,
      identifier: certificateData.fileName + index,
      fileResource: null,
      url: certificateData.filePath,
      name: certificateData.fileName,
      type: certificateData.contentType,
      progress: 100,
      state: 'UPLOADED',
      lastModifiedDate: new Date().toLocaleDateString(),
      errorMessage: '',
      icon: getFileIconByExtension(certificateData.filePath),
    };

      newCertificates.push(fileObject)
    }
    return {
      ...eligibleFormData.educationQualifications,
      certificate: newCertificates,
      graduations: newGraduations
    }
  }

  const handleUpdateEducationQualification = (item, index) => {
    const updatedData = {
      ...eligibleFormData,
      educationQualifications: {
        ...eligibleFormData.educationQualifications,
        graduations: 
        eligibleFormData.educationQualifications.length === 0 ? [item] :
        eligibleFormData.educationQualifications.graduations.map((grad, i) =>
          i === index ? item : grad
        ),
      },
    };

    setEligibleFormData(updatedData);
    validationForm(updatedData);
  }

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
       
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          scale,
          rotate,
        )
      }
    },
    100,
    [completedCrop, scale, rotate],
  )

  function onSelectFile(e) {
    if (e.files && e.files.length > 0) {
      if (e.files[0].size > maxFileSize) {
        errorToast?.current?.show({ 
          severity: "error", 
          summary: '',
          detail: invalidMessage.uploadFileTooLarge + `(> ${maxFileSize/(1024 * 1024)}MB)`,
          life: 3000, 
          content: (props) => ErrorTemplate(props)
        });
        return
      }

      setIsUploading(true);
      const file = e.files[0];
      const allowedImageExtensions = FileTypesAllowed.ImageExtendtions;
  
      const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
      
      if (!allowedImageExtensions.includes(fileExtension)) {
        errorToast?.current?.show({ 
          severity: "error", 
          summary: '',
          detail: invalidMessage.uploadFileFailMessage,
          life: 3000, 
          content: (props) => ErrorTemplate(props)
        });
        setIsUploading(false);
        return;
      }
      
      setCrop(undefined) 
      const reader = new FileReader()
      reader.addEventListener('load', () =>
        setTempImgURL(reader.result?.toString() || ''),
      )
      reader.readAsDataURL(file)
      setVisibleCrop(true)
    }
  }

  function onImageLoad(e) {
    if (aspect) {
      const { width, height } = e.currentTarget
      setCrop(centerAspectCrop(width, height, aspect))
    }
  }

  async function onDownloadCropClick() {
    const image = imgRef.current;
    const crop = completedCrop;
    const type = 'image/png';
    const filename = 'avatar';

    if (!image || !crop?.width || !crop?.height) {
      throw new Error('Crop canvas does not exist')
    }

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const cropX = crop.x * scaleX;
    const cropY = crop.y * scaleY;
    const cropWidth = crop.width * scaleX;
    const cropHeight = crop.height * scaleY;

    const OUTPUT_WIDTH = 384;
    const ASPECT_RATIO = 3/4;
    const OUTPUT_HEIGHT = Math.round(OUTPUT_WIDTH / ASPECT_RATIO);

    const offscreen = new OffscreenCanvas(OUTPUT_WIDTH, OUTPUT_HEIGHT);
    const ctx = offscreen.getContext('2d');
    if (!ctx) throw new Error('No 2d context');

    ctx.drawImage(
      image,
      cropX,
      cropY,
      cropWidth,
      cropHeight,
      0,
      0,
      OUTPUT_WIDTH,
      OUTPUT_HEIGHT
    );

    const blob = await offscreen.convertToBlob({ type });
    const newFile = new File([blob], filename, { type });

    const uploadedFile = await uploadFile(newFile);
    setUploadedProfileImage(uploadedFile.filePath);

    const updatedData = {
        ...eligibleFormData,
        profileImage: uploadedFile.filePath,
    };
    setEligibleFormData(updatedData);
    setValue("uploadImage", uploadedFile.filePath);
    
    trigger("uploadImage");
    validationForm(updatedData);
    handleHideCrop();
    successToast?.current.show({ 
        severity: "success", 
        summary: '',
        detail: invalidMessage.uploadFileSuccessMessage,
        life: 3000, 
        content: (props) => SuccessTemplate(props)
      });
  }

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {

        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          scale,
          rotate,
        )
      }
    },
    100,
    [completedCrop, scale, rotate],
  )

  return (
    isLoading ?
      <div ref={dialogRef}
       className="px-3 keduall-scrollbar border-radius-bottom-125 trainer-registration-wrapper p-2 max-h-full"
       >
          <div className="flex flex-row h-3rem relative w-full m-2">
            <h1 className="flex keduall-typography heading-h1-semibold-600 text-primary-txt-color mb-075 animate__animated animate__fadeInDown w-full justify-content-center">
              {formElement.formTitle}
            </h1>
            <div className="keduall-icon form-icon-wrapper absolute left-97">
              <button className="clear-icon" onClick={() => handleHide()}><i className="pi pi-times"></i></button>
            </div>
          </div>

          <div className="split-container flex flex-wrap relative justify-content-between flex-column">

          <div className="w-full keduall-typography text-16-semibold-600 flex justify-content-center align-items-center text-center text-default-txt">
            {isSubmitted
              &&
              <div className="flex border-radius-075 p-4 border-accent-focus align-items-center flex-row justify-content-center">
                <p className="font-size-42">🎉</p>
                <div className="flex w-8">
                  {formElement.lastFormPage.title}
                </div>
                <p className="font-size-42">🎉</p>
              </div>
            }
          </div>

          {!isSubmitted && <div className="w-full pt-5">
            <Tooltip target=".label-tooltip" className="keduall-tooltip"/>

            <form
              className={`lg:px-3 w-full gap-4 ${isSubmitting ? 'pointer-events-none opacity-60 relative' : ''}`}
              onSubmit={handleSubmit(onSubmit)}
              encType="multipart/form-data"
              disabled={isSubmitting}
            >
              {/* Basic Information */}
              <div className="split-container">
                <div className="right-section gap-5">
                  {/* Row 1 - Name*/}
                  <div className="flex flex-row gap-4 w-full justify-content-center align-items-start flex-wrap md:flex-nowrap">
                    {/* Name Section */}
                    <div className="md:w-half w-full flex">
                      {/* First Name Section */}
                      <div className="md:w-half pr-3">
                        <label className="keduall-typography text-16-normal-400 text-default-txt">
                          {formElement.firstFormPage.nameLabel}&nbsp;
                          <span className="p-error">*</span>
                          <span
                            className="pi pi-question-circle label-tooltip pl-2"
                            data-pr-tooltip={formElement.sharedFieldToolTip}
                            data-pr-position="top"
                          ></span>

                        </label>
                        <div className="input-wrapper">
                          <Controller
                            name="firstName"
                            control={control}
                            defaultValue={eligibleFormData.firstName}
                            rules={{
                              required: invalidMessage.requiredField,
                            }}
                            render={({ field }) => (
                              <InputText
                                {...field}
                                type="text"
                                placeholder={formElement.firstFormPage.namePlaceholder}
                                className={`w-full keduall-form text-default-txt input-default-default keduall-typography text-16-normal-400 ${errors.firstName ? "p-invalid" : ""
                                  }`}
                                onChange={handleInputChange(field)}
                                maxLength={50}
                                disabled={isSubmitting}
                              />
                            )}
                          />
                        </div>
                        {getFormErrorMessage("firstName")}
                        <small className="keduall-typography text-12-normal-400 text-secondary-txt h-1rem flex"></small>
                      </div>
                      {/* Last Name Section */}
                      <div className="md:w-half">
                      <label className="keduall-typography text-16-normal-400 text-default-txt">
                        {formElement.firstFormPage.lastNameLabel}&nbsp;
                        </label>
                        <div className="input-wrapper">
                          <Controller
                            name="lastName"
                            control={control}
                            defaultValue={eligibleFormData.lastName}
                            rules={{
                              required: invalidMessage.requiredField,
                            }}
                            render={({ field }) => (
                              <InputText
                                {...field}
                                type="text"
                                placeholder={formElement.firstFormPage.lastnamePlaceholder}
                                className={`w-full keduall-form text-default-txt input-default-default keduall-typography text-16-normal-400 ${errors.lastName ? "p-invalid" : ""
                                  }`}
                                onChange={handleInputChange(field)}
                                maxLength={50}
                                disabled={isSubmitting}
                              />
                            )}
                          />
                        </div>
                        {getFormErrorMessage("lastName")}
                        <small className="keduall-typography text-12-normal-400 text-secondary-txt h-1rem flex"></small>
                      </div>
                    </div>

                    {/* Nick Name Section */}
                    <div className="md:w-half w-full flex flex-column">
                      <label className="keduall-typography text-16-normal-400 text-default-txt">{formElement.firstFormPage.nicknameLabel}&nbsp;<span className="p-error">*</span> </label>
                      <div className="input-wrapper">
                        <Controller
                          name="nickName"
                          control={control}
                          defaultValue={eligibleFormData.nickName}
                          rules={{
                            required: invalidMessage.requiredField,
                          }}
                          render={({ field }) => (
                            <InputText
                              {...field}
                              type="text"
                              placeholder={formElement.firstFormPage.nicknamePlaceholder}
                              className={`w-full keduall-form text-default-txt input-default-default keduall-typography text-16-normal-400 ${errors.nickName ? "p-invalid" : ""
                                }`}
                              onChange={handleInputChange(field)}
                              maxLength={100}
                              disabled={isSubmitting}
                            />
                          )}
                        />
                      </div>
                      <small className="keduall-typography text-12-normal-400 text-secondary-txt">{formElement.firstFormPage.note}</small>
                      {getFormErrorMessage("nickName")}
                    </div>
                  </div>

                  {/* Row 2 - Gender */}

                  <div className="flex flex-row justify-content-start align-items-center">
                    <div className="flex flex-row justify-content-start align-items-center gap-4">
                      <div className="keduall-typography text-16-semibold-600 text-default-txt" >{formElement.firstFormPage.genderLabel}&nbsp;<span className="p-error">*</span>
                        <span 
                          className="pi pi-question-circle label-tooltip pl-2"
                          data-pr-tooltip={formElement.sharedFieldToolTip}
                          data-pr-position="top"
                        ></span> 
                      </div>
                      <div className="flex align-items-center gap-2">
                        <RadioButton
                          inputId="genderFemale"
                          name={formElement.firstFormPage.genderFemaleOptionLabel}
                          value={GENDERS.FEMALE.toUpperCase()}
                          onChange={(e) => handleGenderChange(e.value)}
                          checked={eligibleFormData.gender === GENDERS.FEMALE.toUpperCase()}
                          disabled={isSubmitting} />
                        <label htmlFor="genderFemale" className="flex keduall-typography text-16-normal-400 text-default-txt">{formElement.firstFormPage.genderFemaleOptionLabel}</label>
                      </div>
                      <div className="flex align-items-center gap-2">
                        <RadioButton
                          inputId="genderMale"
                          name={formElement.firstFormPage.genderMaleOptionLabel}
                          value={GENDERS.MALE.toUpperCase()}
                          onChange={(e) => handleGenderChange(e.value)}
                          checked={eligibleFormData.gender === GENDERS.MALE.toUpperCase()}
                          disabled={isSubmitting}
                        />
                        <label htmlFor="genderMale" className="flex keduall-typography text-16-normal-400 text-default-txt">{formElement.firstFormPage.genderMaleOptionLabel}</label>
                      </div>
                    </div>
                  </div>

                  {/* Row 3 - Phone */}
                  <div className="flex flex-column">
                    <label className="keduall-typography text-default-txt text-16-normal-400">{formElement.firstFormPage.phoneLabel}&nbsp;<span className="p-error">*</span>
                        <span 
                          className="pi pi-question-circle label-tooltip pl-2"
                          data-pr-tooltip={formElement.sharedFieldToolTip}
                          data-pr-position="top"
                        ></span> 
                      </label>
                    <div className="input-wrapper">
                      <Controller
                        name="phone"
                        control={control}
                        defaultValue={eligibleFormData.phone}
                        rules={{
                          required: invalidMessage.requiredField,
                          
                        }}
                        render={({ field, fieldState }) => (
                          <PhoneNumberInput
                            {...field}
                            value={eligibleFormData.phone}
                            country={countryCode}
                            placeholder={formElement.firstFormPage.phonePlaceholder}
                            invalidMessage={invalidMessage.invalidPhoneNumber}
                            onchange={handlePhoneChange}
                            hasError={errors.phone}
                            options={phoneCodeOptions}
                            disabled={isSubmitting}
                          />
                        )}
                      />
                    </div>
                  </div>

                  {/* Row 4 - Email */}
                  <div className="flex flex-column">
                    <label className="keduall-typography text-16-normal-400 text-default-txt">{formElement.firstFormPage.emailLabel}&nbsp;<span className="p-error">*</span>
                    </label>
                    <div className="input-wrapper">
                      <Controller
                        name="email"
                        control={control}
                        defaultValue={eligibleFormData.email}
                        value={eligibleFormData.email}
                        rules={{
                          required: invalidMessage.requiredField,
                          pattern: {
                            value:
                              emailRegex,
                            message: invalidMessage.invalidEmail,
                          },
                        }}
                        render={({ field, fieldState }) => (
                          <InputText
                            {...field}
                            type="email"
                            placeholder={formElement.firstFormPage.emailPlaceholder}
                            className={`keduall-form input-default-default w-full keduall-typography text-16-normal-400 text-default-txt opacity-100 ${
                              fieldState.error ? 'p-invalid' : ''
                            }`}
                            readOnly={true}
                            disabled={isSubmitting}
                          />
                        )}
                      />
                    </div>
                    {getFormErrorMessage("email")}
                    {emailError && (
                      <small className="block p-error">{invalidMessage.invalidEmail}</small>
                    )}
                  </div>

                  {/* Row 5 - Country */}
                  <div className="flex flex-row gap-4 w-full justify-content-center align-items-center flex-wrap md:flex-nowrap">
                    {/* originCountry Section */}
                    <div className="md:w-half w-full flex flex-column">
                      <label className="keduall-typography text-16-normal-400 text-default-txt">{formElement.firstFormPage.originCountryLabel}&nbsp;<span className="p-error">*</span>
                          <span 
                            className="pi pi-question-circle label-tooltip pl-2"
                            data-pr-tooltip={formElement.sharedFieldToolTip}
                            data-pr-position="top"
                          ></span> 
                      </label>
                      <div className="input-wrapper">
                      <Controller
                        name="originCountry"
                        control={control}
                        defaultValue={eligibleFormData.originCountry?.code || ""}
                        value={eligibleFormData.originCountry?.code || ""}
                        rules={{
                          required: invalidMessage.requiredField,
                        }}
                        render={({ field, fieldState }) => (
                          <Dropdown
                            {...field}
                            options={nationalityOptions}
                            type="text"
                            filter={true}
                            optionLabel="name"
                            optionValue="code"
                            placeholder={formElement.firstFormPage.originCountryPlaceholder}
                            panelClassName="keduall-form dropdown-input-panel"
                            valueTemplate={selectedCountryTemplate}
                            itemTemplate={countryOptionTemplate}
                            className={`w-full keduall-form text-default-txt input-default-default keduall-typography text-16-normal-400 ${
                              fieldState.error ? 'p-invalid' : ''
                            }`}
                            value={eligibleFormData.originCountry?.code}
                            onChange={(e) => handleOriginCountryChange(e.value)}
                            appendTo="self"
                            disabled={isSubmitting}
                          />
                        )}
                      />
                      </div>
                      {getFormErrorMessage("originCountry")}

                    </div>

                    {/* residenceCountry Section */}
                    <div className="md:w-half w-full flex flex-column">
                      <label className="keduall-typography text-16-normal-400 text-default-txt">{formElement.firstFormPage.residenceCountryLabel}&nbsp;<span className="p-error">*</span></label>
                      <div className="input-wrapper">
                        <Controller
                          name="residenceCountry"
                          control={control}
                          defaultValue={eligibleFormData.residenceCountry?.code || ""}
                          value={eligibleFormData.residenceCountry?.code || ""}
                          rules={{
                            required: invalidMessage.requiredField,
                          }}
                          render={({ field, fieldState }) => (
                            <Dropdown
                              {...field}
                              options={nationalityOptions}
                              filter={true}
                              valueTemplate={selectedCountryTemplate}
                              itemTemplate={countryOptionTemplate}
                              optionLabel="name"
                              optionValue="code"
                              type="text"
                              panelClassName="keduall-form dropdown-input-panel"
                              placeholder={formElement.firstFormPage.residenceCountryPlaceholder}
                              className={`w-full keduall-form text-default-txt input-default-default keduall-typography text-16-normal-400 ${
                                fieldState.error ? 'p-invalid' : ''
                              }`}
                              value={eligibleFormData.residenceCountry?.code}
                              onChange={(e) => handleResidenceCountryChange(e.value)}
                              appendTo="self"
                              disabled={isSubmitting}
                          />
                          )}
                        />
                      {getFormErrorMessage("residenceCountry")}
                        
                      </div>
                    </div>
                  </div>

                  {/* Row 6 - Language spoken */}
                  <div className="flex w-full justify-content-center align-items-center">
                        <Controller
                          name="languageSpoken"
                          control={control}
                          defaultValue={eligibleFormData.languageSpoken || []}
                          value={eligibleFormData.languageSpoken || []}
                          rules={{
                            required: invalidMessage.requiredField,
                            validate: {
                              hasEntries: (value) => {
                                if (!value || value.length === 0) {
                                  return invalidMessage.requiredField;
                                }
                                return true;
                              },
                              allFieldsComplete: (value) => {
                                var data = eligibleFormData.languageSpoken;
                                if (data && data.length > 0) {
                                  const hasIncompleteEntry = data.some(entry => 
                                    !entry.languageCode || !entry.proficiencyCode
                                  );
                                  if (hasIncompleteEntry) {
                                    return invalidMessage.requiredField;
                                  }
                                }
                                return true;
                              }
                            }
                          }}
                          render={({ field, fieldState }) => (
                            languages && <LanguageProficiency
                              {...field}
                              languageOptions={languages}
                              proficiencyOptions={proficiencyOptions}
                              translation={formElement.firstFormPage.languageProficiency}
                              onChange={handleLanguageSpokenChange}
                              value={eligibleFormData.languageSpoken}
                              hasError={!!fieldState.error}
                              errorMessage={() => getFormErrorMessage("languageSpoken")}
                              disabled={isSubmitting}
                              />
                            )}
                        />
                  </div>

                </div>
              </div>

              {/* Upload Image */}
              <div className="right-section w-full pt-5">
                <Tooltip target=".label-tooltip" className="keduall-tooltip"/>
                <div className="split-container flex flex-row justify-content-center align-items-center gap-5 flex-wrap md:flex-nowrap">
                  <div className="flex flex-column md:w-9 w-full justify-content-center align-items-center text-center gap-3 p-3 bg-primary-primary-1 border-radius-1563">
                    <div className="flex keduall-typography heading-h3-semibold-600  text-primary-default text-default-txt">{formElement.secondFormPage.noteTitle}</div>
                    <div className="flex flex-column keduall-typography text-16-normal-400 text-default-txt justify-content-center align-items-center">
                      <div className="flex">{formElement.secondFormPage.noteLine1}</div>
                      <div className="flex">{formElement.secondFormPage.noteLine2}</div>
                      <div className="flex">{formElement.secondFormPage.noteLine3}</div>
                      <div className="flex">{formElement.secondFormPage.noteLine4}</div>
                    </div>
                    <div className="flex flex-row gap-0625 flex-wrap md:flex-nowrap">
                      <img src={formElement.secondFormPage.rightExample.img1} alt="" className="flex md:w-30rem w-full" />
                    </div>
                    <div></div>
                  </div>

                  <div className="flex flex-column gap-4 align-items-center justify-content-between h-webkit-fill-available">
                    <div className="w-full keduall-typography text-16-semibold-600 flex justify-content-center align-items-center text-center text-default-txt">
                      <div className="flex border-radius-075 border-accent-focus p-4 justify-content-center align-items-center text-center white-space-break-spaces">
                        {steps[1].pageTitle}
                      </div>
                    </div>

                    <Controller
                      name="uploadImage"
                      control={control}
                      defaultValue={uploadedProfileImage || ""}
                      value={uploadedProfileImage || ""}
                      rules={{
                        required: invalidMessage.requiredField,
                      }}
                      render={({ field, fieldState }) => (
                        uploadedProfileImage ? 
                          <div className="keduall-img img-container">
                            <img
                              src={modifyImageUrl(uploadedProfileImage)}
                              alt="Profile Avatar"
                              className="w-full"
                            />
                          </div>
                          : <div className="split-container flex flex-column justify-content-center align-items-center gap-1">
                            <div className="flex justify-content-center align-items-center keduall-img img-3x4 keduall-typography text-14-semibold-600 text-default-txt standard-border">
                              {!isUploading ?
                                <div className="flex w-full justify-content-center align-items-center">
                                  <img src={require('../../icons/business-female-avatar.png')} className="w-full"/>
                                </div>
                                : <div className="keduall-loading-image-container ">
                                  <ProgressSpinner className="w-2rem h-2rem" strokeWidth="8" animationDuration=".5s" />
                                </div>
                              }
                            </div>
                            <div className="flex w-full justify-content-center align-items-center">
                              {getFormErrorMessage("uploadImage")}
                            </div>
                            <div className="text-secondary-txt">
                              <small>(*) {translateText.COMMON_ITEMS_MAX_FILESIZE.replace('{{size}}', '50')}</small>
                            </div>
                          </div>
                        )}
                    />  
                    <FileUpload
                      name="profilePhoto"
                      mode="basic"
                      auto
                      url="/"
                      accept={FileTypesAllowed.ImageExtendtionsInput}
                      chooseLabel={
                        <div className="">
                          {isUploading ? formElement.secondFormPage.loadingUploadButton : formElement.secondFormPage.uploadButton}
                        </div>
                      }
                      chooseOptions={{
                        className: `keduall-buttons  button-filled-default-small-primary keduall-typography text-14-semibold-600`
                      }}
                      onSelect={onSelectFile}
                      disabled={isSubmitting}
                    />
                    <Dialog header={formElement.secondFormPage.uploadImageDialogTitleLabel} contentClassName="px-4 border-radius-bottom-125 w-full flex flex-column justify-content-between" headerClassName="border-radius-top-125 p-4 text-default-txt" visible={visibleCrop} onHide={handleHideCrop} draggable={false} resizable={false} className="trainer-registration-wrapper trainer-registration-crop-imgae-wrapper h-max max-h-full">
                      {tempImgURL && <div className="flex flex-row gap-5 flex-wrap md:flex-nowrap w-full">
                        <div className="flex flex-grow-1 justify-content-center align-items-center">
                          <div className="flex w-full justify-content-center align-items-center">
                          <ReactCrop
                            crop={crop}
                            onChange={(_, percentCrop) => setCrop(percentCrop)}
                            onComplete={(c) => {setCompletedCrop(c); setCrop(c); }}
                            aspect={aspect}
                            minHeight={minCropHeight}
                          >
                            <img
                              className="border-primary-br max-h-20rem"
                              ref={imgRef}
                              alt="Crop me"
                              src={tempImgURL}
                              style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
                              onLoad={onImageLoad}
                            />
                          </ReactCrop>
                          </div>
                        </div>
                        <div className="avatar-image-tutor-wrapper">
                          <p className="keduall-typography text-16-medium-500 mb-2 text-default-txt">{formElement.secondFormPage.uploadReviewImageLabel}</p>
                          <div className="flex justify-content-between gap-2">
                            <div className="avatar-image-review img-3x4 keduall-img flex-shrink-0">
                              {
                              completedCrop && <canvas
                                ref={previewCanvasRef}
                                className="keduall-img img-3x4 border-primary-br object-contain"
                                style={{
                                  width: completedCrop.width,
                                  height: completedCrop.height,
                                }}
                              />}
                            </div>
                          </div>
                        </div>
                      </div>}

                      <div className="flex justify-content-end gap-2 py-12px">
                        <Button className="keduall-buttons button-text-normal-secondary" onClick={handleHideCrop}>
                          <p className="keduall-typography text-16-semibold-600">{formElement.actionButton.cancel}</p>
                        </Button>
                        <span
                          className={`${(!completedCrop || completedCrop.height < minCropHeight) ? "p-disabled" : "" } keduall-buttons button-filled-default-normal-primary keduall-typography text-16-semibold-600 text-white-txt`}
                          onClick={onDownloadCropClick}
                        >
                          <span>
                            {formElement.actionButton.save}
                          </span>
                        </span>
                      </div>
                    </Dialog>
                  </div>
                </div>
              </div>

              {/* Education Qualification Section */}
              <div className="split-container pt-5">
                <div className="w-full keduall-typography text-16-semibold-600 flex justify-content-center align-items-center text-center text-default-txt">
                  <div className="flex border-radius-075 border-accent-focus p-4 justify-content-center align-items-center text-center white-space-break-spaces">
                    {steps[2].pageTitle}
                  </div>
                </div>
                <div className="right-section gap-5">
                  {/* EducationQualification */}
                  <div className="flex justify-content-center align-items-center"></div>
                    <Controller
                      name="educationQualification"
                      control={control}
                      defaultValue={getEducationQualificationsValue() || []}
                      value={getEducationQualificationsValue() || []}
                      rules={{
                        required: invalidMessage.requiredField,
                        validate: {
                          allFieldsComplete: (value) => {
                            var data = getEducationQualificationsValue();
                            if (!data || !data.certificate || data.certificate.length === 0) {
                              return invalidMessage.requiredField;
                            }

                            if (data && data.certificate.length > 0 && data.graduations.length > 0) {
                              const hasIncompleteEntry = data.graduations.some(entry => 
                                !entry.university 
                                || !entry.department 
                                || !entry.degree 
                                || !entry.graduationStatus
                              );
                              if (hasIncompleteEntry) {
                                return invalidMessage.requiredField;
                              }
                            }
                            return true;
                          }
                        }
                      }}
                      render={({ field, fieldState }) => (
                        <EducationQualification
                        translateText={translateText}
                        value={getEducationQualificationsValue()}
                        onRemoveGraduation={handleUpdateGraduations}
                        onRemoveCertificate={handleRemoveCertificate}
                        onUploadCertificate={handleUpdateCertificates}
                        translation={formElement.thirdFormPage}
                        errorToast={errorToast}
                        successToast={successToast}
                        invalidMessage={invalidMessage}
                        onAddGraduation={handleAddEducationQuafificaion}
                        onGraduationChange={handleUpdateEducationQualification}
                        degreeOptions={degreeOptions}
                        graduationStatusOptions={graduationStatusOptions}
                        hasError={!!fieldState.error}
                        errorMessage={() => getFormErrorMessage("educationQualification")}
                        disabled={isSubmitting}
                        ></EducationQualification>
                        )}
                      />  
                </div>
              </div>

              {/* Introduce yourself Section */}
              <div className="flex flex-column pt-5 gap-5">
                <div className="w-full keduall-typography text-16-semibold-600 flex justify-content-center align-items-center text-center text-default-txt">
                  <div className="flex border-radius-075 border-accent-focus p-4 justify-content-center align-items-center text-center white-space-break-spaces">
                    {steps[4].pageTitle}
                  </div>
                </div>
                <div className="input-wrapper w-full justify-content-center align-items-center flex flex-column">
                  <Controller
                    name="selfIntroduction"
                    control={control}
                    defaultValue={eligibleFormData.selfIntroduction}
                    rules={{
                      required: invalidMessage.requiredField,
                      validate: {
                        notEmpty: (value) => {
                          if (!value || value.trim().length === 0) {
                            return invalidMessage.requiredField;
                          }
                          return true;
                        },
                        minLength: (value) => {
                          if (value && value.trim().length < SELFINTRODUCTION_MINLENGTH) {
                            return `Minimum length is ${SELFINTRODUCTION_MINLENGTH} characters`;
                          }
                          return true;
                        }
                      }
                    }}
                    
                    render={({ field }) => (
                      <div className="flex flex-column w-full justify-content-center align-items-center gap-0125 p-4 bg-primary-primary-1 border-radius-1563">
                        <div className="flex keduall-typography text-16-normal-400 justify-content-start w-full text-default-txt">{formElement.fourthFormPage.descriptionTitle}&nbsp;<span className="p-error">*</span></div>
                        <InputTextarea
                          {...field}
                          placeholder={formElement.fourthFormPage.descriptionPlaceholder}
                          className={`w-full border-radius-075 p-075 text-default-txt keduall-typography text-16-normal-400 h-15rem ${errors.selfIntroduction ? "p-invalid" : ""
                            }`}
                          onChange={handleInputChange(field)}
                          maxLength={SELFINTRODUCTION_MAXLENGTH}
                          minLength={SELFINTRODUCTION_MINLENGTH}
                          disabled={isSubmitting}
                        />
                      </div>
                    )}
                  />
                  <div className="flex justify-content-between flex-row align-items-center w-full px-6">
                    <small className="keduall-typography text-12-normal-400 text-secondary-txt">{formElement.fourthFormPage.selfIntroductionNote}</small>
                    <small className={`keduall-typography text-12-normal-400 ${(eligibleFormData?.selfIntroduction?.length ?? 0) > SELFINTRODUCTION_MAXLENGTH ? "p-error" : "text-secondary-txt"}`}>{eligibleFormData?.selfIntroduction?.length ?? 0}/{SELFINTRODUCTION_MAXLENGTH}</small>
                  </div>
                </div>
              </div>
            </form>
          </div>}

          {isSubmitted && (
            <div className="right-section w-full pt-5">
              <div className="flex flex-column justify-content-end align-items-center gap-5">
                {/* Description */}
                <div className="flex flex-column border-radius-15 shadow-s-5 md:w-6 p-5 relative">
                  <img className="absolute top-0 left-0 w-full border-radius-15" src={formElement.lastFormPage.cardImg} alt="" />
                  <div className="flex w-full justify-content-end align-items-center absolute top-0 right-0 pr-6 pt-1">
                    <div className="keduall-typography cherry-bomb-one-normal text-white-txt z-2">DOTORE</div>
                  </div>
                  <div className="my-5 flex flex-row gap-5 flex-wrap md:flex-nowrap justify-content-center md:justify-content-start relative">
                    {/* <img className="flex" src={eligibleFormData.profileImage} alt="" /> */}
                    <img className="flex keduall-img img-3x4 md:w-5" src={modifyImageUrl(uploadedProfileImage)} alt="" />

                    <div className="flex flex-column gap-4 justify-content-center align-items-center md:w-8">
                      <div className="keduall-typography heading-h4-semibold-600 text-primary-default text-center w-10 md:w-full word-wrap-break-word">{eligibleFormData.nickName}</div>
                      <div className="flex flex-column justify-content-center align-items-center w-full">
                        <div className="keduall-typography text-16-normal-400 text-default-txt flex-wrap text-center w-full word-wrap-break-word">{eligibleFormData.email}</div>
                        <div className="keduall-typography text-16-normal-400 text-default-txt">{getCountryName(eligibleFormData.originCountry.code)}</div>
                      </div>
                    </div>
                  </div>
                  <img className="absolute bottom-0 left-0 w-full border-radius-15" src={formElement.lastFormPage.cardImg2} alt="" />
                </div>
              </div>
            </div>
          )}

          <TrainerRegistrationFormFooter
            isSubmitted={isSubmitted}
            isSubmitting={isSubmitting}
            invalidForm={invalidForm}
            formElement={formElement}
            onSubmit={onSubmit}
            isApprovedPolicy={isApprovedPolicy}
            onApprovePolicy={(value) => setIsApprovedPolicy(value)}
            disabled={isSubmitting}
          />
        </div>
        <Toast ref={errorToast} position="bottom-right" className="keduall-toast"/>
        <Toast ref={successToast} position="bottom-right" className="keduall-toast"/>

        <canvas
          ref={canvasRef}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            pointerEvents: "none",
            zIndex: 10,
          }}
        />
      </div> : <div></div>
  );
};

export default TrainerRegistrationForm;
